import React from 'react'
import LoaderItemFeed from './loader-item-feed'

class LoadingItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      type: props.type

    }
  }

  render() {
    return (
      this.state.type === 'Feed' ?
        <LoaderItemFeed /> :
        <div className="afd-story afd-story--loading"></div>
    )
  }
}

export default LoadingItem;